//import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Content = styled.div`
  .filter-action-btn {
    font-size: 0.775rem;
  }
`;
